// eslint-disable-next-line no-restricted-imports
import {
  PriceAlert as IPriceAlert,
  PriceAlertConditionEnum,
  PriceAlertSentimentEnum,
} from '@eih-netbroker/api-price-alert';
import { ListedInstrument } from '@eih-netbroker/common';
import { atom } from 'jotai';

export const TriggerState = PriceAlertConditionEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TriggerState = (typeof PriceAlertConditionEnum)[keyof typeof PriceAlertConditionEnum];

export const SentimentType = PriceAlertSentimentEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SentimentType = (typeof PriceAlertSentimentEnum)[keyof typeof PriceAlertSentimentEnum];

export type PriceAlert = Omit<IPriceAlert, 'ric' | 'currency' | 'ticker'> & {
  instrument: ListedInstrument;
};

export type PriceAlerts = {
  priceAlerts: Array<PriceAlert>;
  isLoading: boolean;
  hasError?: boolean;
};

export const priceAlertsAtom = atom<PriceAlerts>({
  priceAlerts: [],
  isLoading: false,
  hasError: false,
});
